import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex gap-x-1 items-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Gagal Scan ")
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "flex gap-x-1 items-center text-red-lp-100 font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, " Lihat ", -1)
const _hoisted_6 = {
  class: "flex flex-col relative py-4 text-black-lp-100 text-sm font-montserrat rounded-lg bg-white border border-gray-lp-1600",
  style: {"width":"395px"}
}
const _hoisted_7 = { class: "font-semibold px-3" }
const _hoisted_8 = {
  class: "flex flex-col overflow-auto mt-3 px-3 log-process-scan-panel__scroll",
  style: {"max-height":"175px"}
}
const _hoisted_9 = { class: "flex flex-col gap-y-1" }
const _hoisted_10 = { class: "text-red-lp-2400 font-bold text-xs" }
const _hoisted_11 = { class: "leading-3" }
const _hoisted_12 = { class: "whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.entries.length)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTable && _ctx.openTable(...args))),
          class: "tiering-pos flex justify-center items-center gap-x-4 text-sm text-black-lp-100 px-2 py-1.5 rounded-2xl border border-blue-lp-200 w-max"
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_Icons, {
              name: "x-circle",
              fill: "",
              class: "w-4 text-red-lp-100"
            }),
            _createVNode("span", null, [
              _hoisted_2,
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.entries.length), 1)
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Icons, {
              name: "chevron-down",
              fill: "",
              class: "w-4"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      id: "log-process-scan-panel",
      ref: "log-process-scan-panel",
      appendTo: "body",
      class: "w-auto"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode("h3", _hoisted_7, " Daftar gagal scan (" + _toDisplayString(_ctx.entries.length) + ") ", 1),
          _createVNode("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entries, (item) => {
              return (_openBlock(), _createBlock("div", {
                key: item.id,
                class: "flex items-start justify-between gap-x-4 py-1 border-b border-gray-lp-1600 text-10px"
              }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, _toDisplayString(item.shipmentNumber), 1),
                  _createVNode("span", _hoisted_11, _toDisplayString(item.reasonFailed), 1)
                ]),
                _createVNode("span", _hoisted_12, _toDisplayString(_ctx.formatDate(item.scannedAt, "DD MMM YYYY, HH:mm")), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}